import React from 'react';
import {
  View, Text, StyleSheet, FlexStyle,
} from 'react-native';
import getPriorityColor from '../../../components/PriorityColorScheme';
import FlagIcon16 from '../../../components/16pxIcons/FlagIcon16';
import DropdownIcon from '../../../components/16pxIcons/DropdownIcon';

interface PriorityLabelProps {
  priority: number,
  dropdownIconShown?: boolean,
  style?: FlexStyle | FlexStyle[],
}

const PriorityLabel = ({ priority, dropdownIconShown, style }: PriorityLabelProps) => {
  const color: string = getPriorityColor(priority);

  return <View style={[styles.container, { borderColor: color }, style]}>
    <FlagIcon16 {...{ color }} />
    <Text
      style={[styles.text, { color }]}
      selectable={false}
    >
      {`P${priority + 1}`}
    </Text>
    {dropdownIconShown && <DropdownIcon {...{ color }} style={styles.icon} />}
  </View>;
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderRadius: 4,
    paddingHorizontal: 4,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFF',
  },
  text: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_500Medium',
    marginStart: 2,
  },
  icon: {
    marginStart: 2,
  },
});

export default PriorityLabel;
